import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=d806152a&scoped=true&"
import script from "./LabelList.vue?vue&type=script&lang=js&"
export * from "./LabelList.vue?vue&type=script&lang=js&"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=d806152a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d806152a",
  null
  
)

export default component.exports